// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1110": "63ad77bb9265","2339": "f7bb09144e08","6863": "454c9f289029","8696": "bbb68422bd59",}[chunkId] + ".css"
}